import { JSX } from "react";

interface Props {
    initials?: string;
    fullName?: string;
    company?: string;
}

export const AccountButton = (props: Props): JSX.Element => {
    const { initials, fullName, company } = props;
    return (
        <div className="c-account-button">
            <div className="c-account-button__initials">
                <span>{initials}</span>
            </div>
            {(!!fullName || !!company) && (
                <div className="c-account-button__info">
                    {!!fullName && (
                        <span className="c-account-button__name">
                            {fullName}
                        </span>
                    )}
                    {!!company && (
                        <span className="c-account-button__company">
                            {company}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};
